import React, { useState } from 'react';
import {
  Box, Typography, Rating, TextField, Button, Alert
} from '@mui/material';
import api from '../services/api';

const ReviewForm = ({ productId, productName, onSuccess }) => {
  const [formData, setFormData] = useState({
    rating: 5,
    title: '',
    comment: '',
    customerName: '',
    customerEmail: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleRatingChange = (event, newValue) => {
    setFormData(prev => ({
      ...prev,
      rating: newValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.comment.trim()) {
      setError('請輸入評論內容');
      return;
    }

    setSubmitting(true);
    setError(null);

    try {
      await api.post('/reviews', {
        product_id: productId,
        customer_name: formData.customerName || '匿名用戶',
        customer_email: formData.customerEmail,
        rating: formData.rating,
        title: formData.title,
        comment: formData.comment
      });

      setSuccess(true);
      setFormData({
        rating: 5,
        title: '',
        comment: '',
        customerName: '',
        customerEmail: ''
      });

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(err.response?.data?.error || '提交評論失敗，請稍後再試');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <Alert severity="success" sx={{ mt: 2 }}>
        感謝您的評論！評論將在審核後顯示。
      </Alert>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        撰寫評論
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box sx={{ mb: 2 }}>
        <Typography component="legend" variant="body2" gutterBottom>
          評分
        </Typography>
        <Rating
          value={formData.rating}
          onChange={handleRatingChange}
          size="large"
        />
      </Box>

      <TextField
        fullWidth
        label="您的姓名 (選填)"
        value={formData.customerName}
        onChange={handleChange('customerName')}
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="Email (選填，不公開)"
        type="email"
        value={formData.customerEmail}
        onChange={handleChange('customerEmail')}
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="標題 (選填)"
        value={formData.title}
        onChange={handleChange('title')}
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        label="評論內容"
        multiline
        rows={4}
        value={formData.comment}
        onChange={handleChange('comment')}
        required
        sx={{ mb: 2 }}
      />

      <Button
        type="submit"
        variant="contained"
        disabled={submitting}
        fullWidth
      >
        {submitting ? '提交中...' : '提交評論'}
      </Button>
    </Box>
  );
};

export default ReviewForm;
